import { z } from 'zod';
import { EQUATION_MODES, valueRowSchema } from './equation.js';
/**
 * Where a call starts, before the greeting. Only an edge out of Start carries
 * it. Its rows read system and contact variables, the only values known
 * before anyone speaks, joined by "all" or "any". The pre-greeting edges are
 * checked once, when the call starts, in drawn order; the first that holds
 * wins, and the entry edge takes a call none of them holds for.
 */
export const preGreetingConditionSchema = z.object({
    type: z.literal('pre_greeting'),
    mode: z.enum(EQUATION_MODES),
    rows: z.array(valueRowSchema).min(1),
});
/**
 * What a node says when the call starts at it through a pre-greeting edge, in
 * place of its own opening. Said word for word, then the node runs. Absent
 * means the node opens as it does when the call reaches it later.
 */
export const startGreetingShape = {
    startGreeting: z.string().trim().min(1).max(4000).optional(),
};
//# sourceMappingURL=pre-greeting.js.map